const PREFIX = '[DEFERRED_PAYMENTS]';

export const PAYMENT_DETAILS_REQUEST = `${PREFIX} PAYMENT_DETAILS_REQUEST`;
export const PAYMENT_DETAILS_SUCCESS = `${PREFIX} PAYMENT_DETAILS_SUCCESS`;
export const PAYMENT_DETAILS_FAILURE = `${PREFIX} PAYMENT_DETAILS_FAILURE`;
